import { useDatasourceLoader, LoadOutcome } from "./useDatasourceLoader";
import { useUserSettings } from "../context/UserSettingsContext";
import { clearGCGRReportTable } from "../../excel/datasources/reportTables";
import { clearGcgrDataTables } from "../../excel/reports/dataTables";
import { GCGR } from "../../interfaces/GCGRs";
import { clearGCGRCaches } from "../../api/gcgrs";

export function useGcgrLoader() {
  const { loadDatasources } = useDatasourceLoader();
  const { settings } = useUserSettings();

  const loadGcgr = (gcgr: GCGR): Promise<LoadOutcome> => loadDatasources([{ type: "gcgr", gcgr }]);

  /** Drops the GCGR's data from the workbook, leaving sheets and headers so formulas read blank. */
  const clearGcgr = async (): Promise<void> => {
    await clearGCGRReportTable();
    if (settings.hasDataSheets) await clearGcgrDataTables();
    clearGCGRCaches();
  };

  return { loadGcgr, clearGcgr };
}
